// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1BS_b","icon":"SortAdornment_icon__2jLvU","up":"SortAdornment_up__17Zm6","down":"SortAdornment_down__1tYab","active":"SortAdornment_active__3qNs1"};